import React from 'react'
import { TabView, TabPanel } from 'primereact/tabview';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { useContext } from 'react';
import DataContext from '../context/DataContext';
// import Posts from './Posts';
import MessageSubmissions from './notifications/MessageSubmissions';
import PortalSubmissions from './notifications/PortalSubmissions';
import MonitorSubmissions from './notifications/MonitorSubmissions';
import CommentSubmissions from './notifications/CommentSubmissions';









const Notifications = () => {

    const { notifications, setNotifications,
      isLoadingNotifications, setIsLoadingNotifications,
      fetcherrorNotifications, setFetcherrorNotifications } = useContext(DataContext);

    let smsCount = `Messages(${notifications?.messageSubmissions?.total || 0})`;
    let publicCount =`Public Portal(${notifications?.portalSubmissions	?.total || 0})`;
    let HRMCount = `FOH Submissions(${notifications?.incidents?.total || 0})`;
    let commentsCount = `FOH Follow-Ups(${notifications?.comments?.total || 0})`;


  return (
      <div className="card" >
          
          <Card >
              <p className='m-2 p-3 text-center text-primary text-3xl font-semibold' >New Submissions</p>


              <TabView>
                  <TabPanel header={smsCount} leftIcon="pi pi-whatsapp mr-2">
                    <MessageSubmissions/>  
                  </TabPanel>
          
                  <TabPanel header={publicCount} leftIcon="pi pi-globe mr-2">
                      <PortalSubmissions/>
                   </TabPanel>
          
                  <TabPanel header={HRMCount} leftIcon="pi pi-briefcase mr-2" >
                   <MonitorSubmissions/>
                  </TabPanel>
                  
                  <TabPanel header={commentsCount} leftIcon="pi pi-comments mr-2" >
                    <CommentSubmissions/>
                </TabPanel>
            </TabView>

          </Card>

            
        </div>
  )
}

export default Notifications